import React from "react";
import PageHero from "../components/PageHero";
import { BookOpen, FileText, Download, ShieldCheck, GraduationCap, ClipboardCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { useModals } from "../components/modals/ModalProvider";

const RESOURCES = [
  { icon: BookOpen, title: "Cybersecurity Blog", desc: "Executive-level analysis of threats, regulations & industry shifts.", cta: "Read the blog" },
  { icon: FileText, title: "Case Studies", desc: "Anonymized outcomes from our engagements across banking, pharma, manufacturing.", cta: "Explore case studies" },
  { icon: Download, title: "Whitepapers", desc: "Deep-dive research on DPDP, Zero Trust and cloud security.", cta: "Browse whitepapers" },
  { icon: ClipboardCheck, title: "Compliance Guides", desc: "Practical checklists for ISO 27001, SOC 2, RBI and SEBI programs.", cta: "Open guides" },
  { icon: ShieldCheck, title: "Cybersecurity Checklist", desc: "30-point executive checklist mapped to NIST CSF 2.0.", cta: "Get the checklist", action: "checklist" },
  { icon: GraduationCap, title: "Security Awareness", desc: "Training kits, phishing simulation content, board briefings.", cta: "Request materials", action: "callback" },
];

export default function ResourcesPage() {
  const { openDownloadChecklist, openRequestCallback } = useModals();
  return (
    <div data-testid="resources-page">
      <PageHero
        eyebrow="Resources"
        title="Practical playbooks. Sharp perspective."
        subtitle="Curated resources for CISOs, CIOs, compliance and audit leaders. Skimmable, actionable, board-ready."
      />
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {RESOURCES.map((r, i) => {
              const Icon = r.icon;
              return (
                <div
                  key={i}
                  className="card-lift rounded-2xl border border-border bg-card p-6 sm:p-7 flex flex-col"
                  data-testid={`resource-card-${i}`}
                >
                  <div className="h-12 w-12 rounded-xl bg-primary/10 text-primary grid place-items-center">
                    <Icon className="h-5 w-5" strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-5 font-display text-lg sm:text-xl font-semibold">{r.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed flex-1">{r.desc}</p>
                  <Button
                    onClick={r.action === "checklist" ? openDownloadChecklist : openRequestCallback}
                    data-testid={`resource-cta-${i}`}
                    variant="outline"
                    className="mt-5 rounded-full border-primary/30 hover:border-primary self-start"
                  >
                    {r.cta}
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
